import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { type Nullable } from '@Types';
import { type LearnerProject } from 'LearnerProjects';
import { Modal, type ModalProps } from 'Modal';
import { type ProjectGroupMembershipSansProjectGroup } from 'ProjectGroup';
import { type AdminUploadTargetUser, type UploadProjectSubmissionResponse } from './ProjectSubmission.types';
import { ProjectSubmissionForm } from './ProjectSubmissionForm';

function ProjectSubmissionFormModalComponent(props: {
    closeModal: () => void;
    isOpen: boolean;
    project: LearnerProject;
    projectGroupMembership: Nullable<ProjectGroupMembershipSansProjectGroup>;
    onCreateGroup: () => void;
    onViewGroup: () => void;
    // Admin mode props - when provided, submission is created for targetUser instead of current user
    targetUser?: AdminUploadTargetUser;
    cohortId?: string;
    // Callback when upload succeeds - called with response data before showing success state
    onUploadSuccess?: (response: UploadProjectSubmissionResponse) => void;
    // Optional classNames to override Modal slot styles (e.g. z-index for stacking)
    modalClassNames?: ModalProps['classNames'];
}) {
    const {
        closeModal,
        isOpen,
        project,
        projectGroupMembership,
        onCreateGroup,
        onViewGroup,
        targetUser,
        cohortId,
        onUploadSuccess,
        modalClassNames,
    } = props;
    const { t } = useTranslation('back_royal');
    const title = t('submission_form.title');

    if (!isOpen) return null;

    return (
        <Modal
            classNames={{
                header: 'pb-[10px]',
                ...modalClassNames,
            }}
            dismissOnEscape={false}
            dismissOnOverlayClick={false}
            onClose={closeModal}
            scrollBehavior="outside"
            size="2xl"
            title={title}
        >
            <ProjectSubmissionForm
                project={project}
                closeModal={closeModal}
                projectGroupMembership={projectGroupMembership}
                onCreateGroup={onCreateGroup}
                onViewGroup={onViewGroup}
                targetUser={targetUser}
                cohortId={cohortId}
                onUploadSuccess={onUploadSuccess}
            />
        </Modal>
    );
}
export const ProjectSubmissionFormModal = memo(ProjectSubmissionFormModalComponent);
